import { Directive, ElementRef, HostListener, Input, inject } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Directive({
  selector: '[finFormErrorFocus]',
  standalone: false,
})
export class FormErrorFocusDirective {
  private el = inject(ElementRef);

  @Input('finFormErrorFocus') formGroup: UntypedFormGroup;

  @HostListener('submit', ['$event'])
  onFormSubmit(event: Event): void {
    if (this.formGroup && this.formGroup.status === 'INVALID') {
      event.preventDefault();
      const invalidElements = this.el.nativeElement.querySelectorAll(
        'input.ng-invalid, select.ng-invalid, textarea.ng-invalid'
      );
      if (invalidElements.length > 0) {
        invalidElements[0].focus();
      }
    }
  }
}
